
import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export function createStaggerAnimationDelay(index: number, baseDelay: number = 100): string {
  return `${baseDelay * index}ms`
}

